module.exports = __webpack_public_path__ + "static/img/2.b28c0941.png";